import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface SingleUserProps {
  id: number;
  name: string;
  email: string;
  date: number;
  reports: number;
  invitations: number;
}

export const SingleUser = types.model({
  id: types.number,
  name: types.string,
  email: types.string,
  date: types.number,
  reports: types.number,
  invitations: types.number,
});

export type SingleUserSnapshot = SnapshotIn<typeof SingleUser>;
export type SingleUserInstance = Instance<typeof SingleUser>;
